import { render } from "./SeparateUserPage.vue?vue&type=template&id=608a1cc3&scoped=true"
import script from "./SeparateUserPage.vue?vue&type=script&lang=js"
export * from "./SeparateUserPage.vue?vue&type=script&lang=js"

import "./SeparateUserPage.vue?vue&type=style&index=0&id=608a1cc3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608a1cc3"]])

export default __exports__